import types from './types';

const getReport = (reportPath, ids, locReportReqDtoList, queryParams) => ({
  type: types.GET_REPORT,
  params: { reportPath, ids, locReportReqDtoList, queryParams }
});

const getCsvReport = (ids, filters, filterstate, language) => ({
  type: types.GET_CSV_REPORT,
  params: { ids, filters, filterstate, language}
});

export default {
  getReport,
  getCsvReport
};
